// @flow
import PropTypes from "prop-types"

export const PLACE_RESULTS_MODES = {
  NEARBY: "nearby",
  SUGGESTION: "suggestion",
  POPULAR: "popular",
  LAST_SEARCH: "lastSearch",
  INCLUDED: "INCLUDED",
  RECENT: "recent",
}

export const PLACE_MODES = {
  ALL: "all",
  NEARBY: "nearby",
  CITIES_AND_AIRPORTS: "citiesAndAirports",
  COUNTRIES: "countries",
  ANYWHERE: "anywhere",
  RADIUS: "radius",
  UNSELECTED: "unselected",
}

export const PLACE_MODE_KEYS = {
  [PLACE_MODES.ALL]: __("form_search.all_places"),
  [PLACE_MODES.NEARBY]: __("form_search.nearby"),
  [PLACE_MODES.CITIES_AND_AIRPORTS]: __("form_search.cities_and_airports"),
  [PLACE_MODES.COUNTRIES]: __("form_search.countries"),
  [PLACE_MODES.ANYWHERE]: __("form_search.anywhere"),
  [PLACE_MODES.RADIUS]: __("form_search.radius_search"),
}

export const PLACE_VALUE_MODES = {
  TEXT: "text",
  PLACE: "place",
  RADIUS: "radius",
  ANYWHERE: PLACE_MODES.ANYWHERE,
  ID: "id",
  UNSELECTED: PLACE_MODES.UNSELECTED,
  MULTI_PLACE: "multiPlace",
}

export const PLACE_TYPES = {
  AIRPORT: 0,
  COUNTRY: 1,
  CITY: 2,
  TRAIN_STATION: 4,
  AUTONOMOUS_TERRITORY: 3,
  REGION: 5,
  CONTINENT: 6,
  BUS_STATION: 7,
  SPECIAL: 8,
  VIRTUAL: 999,
}

export const PLACE_VALUE_SHAPE = {
  mode: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  error: PropTypes.string,
  loading: PropTypes.bool,
  radius: PropTypes.object,
}

export const CB_SHAPE = {
  [PLACE_MODES.ALL]: PropTypes.func,
  [PLACE_MODES.NEARBY]: PropTypes.func,
  [PLACE_MODES.CITIES_AND_AIRPORTS]: PropTypes.func,
  [PLACE_MODES.COUNTRIES]: PropTypes.func,
  [PLACE_MODES.ANYWHERE]: PropTypes.func,
  [PLACE_MODES.RADIUS]: PropTypes.func,
}

export const ORIGIN_MODES = [
  PLACE_MODES.ALL,
  // PLACE_MODES.NEARBY,
  PLACE_MODES.COUNTRIES,
  PLACE_MODES.RADIUS,
]

export const DESTINATION_MODES = [
  PLACE_MODES.ALL,
  // PLACE_MODES.NEARBY,
  PLACE_MODES.COUNTRIES,
  PLACE_MODES.ANYWHERE,
  PLACE_MODES.RADIUS,
]

export const PLACES_TO_OMIT = {
  origin: ["anywhere"],
  destination: [],
}

// types
// =====
export type PlaceMode =
  | "all"
  | "nearby"
  | "cheapest"
  | "citiesAndAirports"
  | "countries"
  | "anywhere"
  | "radius"

export type PlaceValueMode = "text" | "place" | "radius" | "anywhere" | "id" | "unselected"

export type SimplePickerPlace = {
  modeDefault: PlaceMode,
  modes: Array<PlaceMode>,
}
